import { Logout } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Modal,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";

import api from "../../../api";
import { updateRetailer } from "../../../actions/Retailer";
import Loader from "../../Loader";
import notify from "../../Notification/helper";

const UserMenu = ({ sx = {} }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState("");

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const retailer = useSelector((state) => state.retailer);
  const isAdminUser = api.isAdmin(user);

  const open = Boolean(anchorEl);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    minWidth: "250px",
    maxWidth: "1000px",
    bgcolor: "white",
    p: 4,
    border: "none",
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeRetailer = () => {
    setModalOpen(true);
  };

  const getRetailers = async () => {
    setLoading(true);
    try {
      let res = await api.getListRetailer();
      if (res && res?.length > 0) {
        setOptions(res);
      }
      setLoading(false);
    } catch (err) {
      notify("error", err?.message || "Failed to update retailer");
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selected) {
      return;
    } else {
      setLoading(true);
      try {
        await api.updateAdminRetailer({
          id: user?.id,
          retailer: selected,
        });
        const userResponse = await api.getUserAndRetailer();
        const newRetailer = userResponse.retailer;
        dispatch(updateRetailer(newRetailer));
        setLoading(false);
        setModalOpen(false);
      } catch (err) {
        notify("error", err?.message || "Failed to update retailer");
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (retailer) {
      setSelected(retailer?.id);
    }
    isAdminUser && getRetailers();
  }, []);

  return (
    <>
      <Box sx={sx}>
        <Stack direction="row" alignItems="center" spacing={2}>

            <Avatar
              sx={{
                width: 32,
                height: 32,
                textTransform: "uppercase",
                background: retailer.button_background_color,
              }}
            >
              {user?.first_name?.slice(0, 1)}
            </Avatar>

            <Divider orientation="vertical" flexItem />

            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 'bold',
                flexGrow: 1,
              }}
            >
              {user?.email}
            </Typography>
          
          <Link
            to="/login" 
            style={{ textDecoration: "none" }}
          >
            <Box sx={{ ml: 'auto' }}>
              <Logout />
            </Box>
          </Link>
        </Stack>
      </Box>
      <Modal open={modalOen} onClose={() => setModalOpen(false)}>
        {loading ? (
          <Loader />
        ) : (
          <Box sx={style}>
            <>
              <Typography
                sx={{ fontWeight: "600", mb: 3 }}
                variant="h6"
                component="h2"
              >
                CHOOSE A RETAILER
              </Typography>

              <select
                value={selected}
                onChange={(event) => {
                  setSelected(event?.target?.value);
                }}
                style={{
                  width: "100%",
                  padding: "5px",
                  height: "40px",
                  borderRadius: "3px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                <option value="" disabled>
                  Select a retailer
                </option>
                {options.map((option) => (
                  <option
                    style={{
                      fontSize: "16px",
                    }}
                    key={option?.id}
                    value={option?.id}
                  >
                    {option?.translations?.[0]?.retailer_name || ""}
                  </option>
                ))}
              </select>
              <Button
                disabled={loading}
                onClick={handleSubmit}
                variant="contained"
                sx={{ mt: 5 }}
              >
                Save
              </Button>
            </>
          </Box>
        )}
      </Modal>
    </>
  );
};

export default UserMenu;
